


















































import { Component, Vue, Watch } from "vue-property-decorator";
import MainMenu from "@/components/MainMenu.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import { settingStorageLocalApi } from "@/getinfo-api/settingsStorage";
import CustomButton from "@/components/form/CustomButton.vue";
import { logout } from "@/getinfo-api/auth";
import { consentModule } from "@/plugins/modules-detect";

@Component({
  components: { CustomButton, MainMenu }
})
export default class Base extends Vue {
  get currentCompany() {
    return getCurrentCompanyId() ? getCurrentCompanyId() : "-1";
  }

  get isNeedShowConsent() {
    const user = this.$store.state?.user?.user?.user;

    const isHasUser = !!user;

    const isNotAcceptedConsent = !user?.consent;

    return isHasUser && isNotAcceptedConsent && this.isConsentModule;
  }

  get locale() {
    return (
      this.$store?.getters?.LOCALIZATION ||
      window.localStorage.getItem("localization") ||
      "not installed"
    );
  }

  get viewKey() {
    return this.currentCompany + "-" + this.locale;
  }

  get isConsentModule() {
    return consentModule();
  }

  exit() {
    logout();
    this.$router.push({ name: "login" });
  }

  @Watch("currentCompany", { immediate: true })
  checkCompany() {
    if (this.currentCompany !== "-1") {
      settingStorageLocalApi.Company.getIsFinishLearningWithEndLr(
        this.currentCompany
      ).then(res => {
        this.$store.commit(
          "companyUtils/changeIsFinishLearningWithEndLr",
          res.isFinish
        );
      });
    }
  }
}
